var CompanyHeadcountRoleCategoryService = (function () {
    function CompanyHeadcountRoleCategoryService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    CompanyHeadcountRoleCategoryService.prototype.getAll = function (CompanyID) {
        return this.$http.post(this.WsUrl + "/GetAllCompanyHeadcountRoleCategory", {
            CompanyID: CompanyID
        });
    };
    CompanyHeadcountRoleCategoryService.$inject = ["$http"];
    return CompanyHeadcountRoleCategoryService;
}());
angular
    .module("London.Services")
    .service("CompanyHeadcountRoleCategoryService", CompanyHeadcountRoleCategoryService);
